import { FlexDiv, HorizontalFlexDiv } from "src/common/styles/div";
import styled from "styled-components";

export const HeaderContainer = styled(FlexDiv)` 
   justify-content: center;
   padding-right: 8px;
`
export const CategoriesContainer = styled(HorizontalFlexDiv) <{ isEmbed?: boolean }>`
    background-color: white;
    box-shadow: ${props => props.isEmbed ? "none" : "0 3px 10px rgb(0 0 0 / 0.2)"};
    align-items: center;
    jsutify-content: space-between;
    padding-left: ${props => props.isEmbed ? "0" : "8px"};
    padding-rightt: 8px;
    gap: 8px;
    overflow-x: scroll;
    border-radius: 8px;
    height: 47px;
`